export default __webpack_public_path__ + "static/media/games_active.0e4327ac.svg";